import { render, staticRenderFns } from "./RequestPoin.vue?vue&type=template&id=1bbae28c&"
import script from "./RequestPoin.vue?vue&type=script&lang=ts&"
export * from "./RequestPoin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports